<template>
    <div class="container h-100 mt-5">
                <div class="d-flex h-100 color-black align-items-center">
                    <div class="w-100 color-black">
                        <h2 class="title">Sleep Jar Soundscapes</h2>
                        <hr class="mb-2"/>
                        <div class="col-sm-12 ml-auto mr-auto mb-5">
                            <div class="row">
                                <print-media-item v-for="(item, itemKey, index) in filteredMedia.SOUND"
                                    v-bind:item="item"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:itemKey="itemKey"
                                    ref="previews"
                                />
                            </div>
                        </div>

                        <h4 class="title">"Alexa, ask Sleep Jar for [thunderstorm] sounds"</h4>

                    </div>
                </div>
            </div>
            </template>

<script>
export default {
    data () {
        return {
            "media": require('../../assets/media.js')
        };
    },
    name: 'sounds',
    metaInfo: {
        title: 'Sound List',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Printable list of sleep sounds available on Sleep Jar.'
            },
            {
                'name': 'apple-itunes-app',
                'content': 'app-id=1587218079'
            },
            {
                'name': 'robots',
                'content': 'noindex'
            }
        ]
    },
    methods: {
        filteredMediaRoughCount (type = "SOUND") {
            return this.filteredMediaCount(type) - this.filteredMediaCount(type)%10;
        },
        filteredMediaCount (type = "SOUND") {
            var keys = Object.keys(this.filteredMedia[type]);
            return keys.length;
        },
    },
    computed: {
        "filteredMedia": function(){
            let media = {
                "SOUND": {},
                "STORY": {},
                "MEDITATION": {},
                "JOURNEY": {}
            };
            Object.entries(this.media).forEach(function([key, item]){
                if(!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()){
                    media[item.type][key] = item;
                }
            });
            return media;
        },
    },
    components: {
    },
    mounted(){
    }
}
</script>
